// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b71292d","453":"0ef05421","732":"0cad2669","977":"fac8e13b"}[chunkId] + ".chunk.js";
};